(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("KosherZmanim", [], factory);
	else if(typeof exports === 'object')
		exports["KosherZmanim"] = factory();
	else
		root["KosherZmanim"] = factory();
})(window, function() {
return 